import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";

export default function Progress({ setMaxValue, maxValue, value, setValue }) {
  // Handle slider value change
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //   const difference = value[1] - value[0];

  return (
    <Box sx={{ width: 200 }}>
      {/* Display dynamic max value */}

      <Slider
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        getAriaValueText={(value) => `${value}°C`}
        min={0}
        max={maxValue} // Dynamic max value
      />
    </Box>
  );
}
